import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _envMap;
import window from 'window-or-global';
import { DEV } from '../globals';
export var MicrosEnv = /*#__PURE__*/function (MicrosEnv) {
  MicrosEnv["ADEV"] = "adev";
  MicrosEnv["STG_EAST"] = "stg-east";
  MicrosEnv["PROD_EAST"] = "prod-east";
  return MicrosEnv;
}({});
export var envMap = (_envMap = {
  local: 'local',
  test: 'test',
  prod: 'prod',
  stg: 'staging'
}, _defineProperty(_envMap, MicrosEnv.ADEV, 'staging'), _defineProperty(_envMap, MicrosEnv.STG_EAST, 'staging'), _defineProperty(_envMap, MicrosEnv.PROD_EAST, 'production'), _envMap);
var SIMPLE_TO_DAMN_COMPLEX_ENV = {
  prod: 'prod-east',
  stg: 'stg-east'
};
var presetEnv;
export var setEnv = function setEnv(env) {
  var envOverride = SIMPLE_TO_DAMN_COMPLEX_ENV[env];
  if (envOverride) {
    presetEnv = envOverride;
  }
};

/**
 * The region specified here is not the correct region for the environment.
 * It's always stg-east/prod-east for staging/production.
 * The environment is set by `setEnv` which is called by products(Jira/Confluence and etc.),
 * but products don't always set the correct region
 * If the environment is not preset by products, it will get it from window.__env__.
 */
export function getEnv() {
  if (presetEnv) {
    return presetEnv;
  }
  if (DEV) {
    return 'local';
  }

  // @ts-ignore
  return window.__env__;
}
export function getMappedEnv() {
  return envMap[getEnv()];
}